// Odia translations
export const or: Record<string, string> = {
  'menu.dashboard': 'ଡ୍ୟାସବୋର୍ଡ',
  'menu.customers': 'ଗ୍ରାହକ',
  'menu.products': 'ଉତ୍ପାଦ',
  'menu.users': 'ବ୍ୟବହାରକାରୀ',
  'menu.settings': 'ସେଟିଂସ',
  'menu.logout': 'ଲଗଆଉଟ',
  'dashboard.title': 'ଡ୍ୟାସବୋର୍ଡ',
  'dashboard.newOrder': 'ନୂତନ ଅର୍ଡର',
  'order.title': 'ନୂତନ ଅର୍ଡର',
  'order.customer': 'ଗ୍ରାହକ',
  'order.products': 'ଉତ୍ପାଦ',
  'order.total': 'ମୋଟ',
  'users.title': 'ବ୍ୟବହାରକାରୀ',
  'users.name': 'ନାମ',
  'users.email': 'ଇମେଲ',
  'common.yes': 'ହଁ',
  'common.no': 'ନା',
  'common.cancel': 'ବାତିଲ କରନ୍ତୁ',
  'common.save': 'ସଂରକ୍ଷଣ କରନ୍ତୁ',
  'common.search': 'ଖୋଜନ୍ତୁ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ଲଗଇନ',
  'login.welcome': 'ସ୍ୱାଗତ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ଇମେଲ',
  'signup.phone': 'ଫୋନ',
  'menu.reportsAndAccounting': 'ରିପୋର୍ଟ ଓ ହିସାବ',
  'menu.systemAndCommunication': 'ସିଷ୍ଟମ ଓ ଯୋଗାଯୋଗ',
};